// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var filterSettings = {
    general: {
        limit: boostPFSConfig.custom.products_per_page,
        loadProductFirst: true,
        numberFilterTree: 2,
        filterTreeMobileStyle: 'style2',
        showLimitList: '12,24,48,70',
    },
    selector: {
        trackingQuickView: '.quick_shop'
    }
};
var boostPFSFilterConfig = boostPFSFilterConfig || {};
boostPFSFilterConfig.selector = filterSettings.selector;
boostPFSFilterConfig.general = boostPFSFilterConfig.general || {};
boostPFSFilterConfig.general = {
    ...boostPFSFilterConfig.general,
    ...filterSettings.general
};
(function() {
    var onSale = false,
        soldOut = false,
        priceVaries = false,
        images = [],
        boostPFSRangeWidths = [180, 330],
        boostPFSScreenWidths = [165, 768];


    BoostPFS.inject(this);

    /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    function prepareShopifyData(data) {
        // Displaying price base on the policy of Shopify, have to multiple by 100
        soldOut = !data.available; // Check a product is out of stock
        if (boostPFSThemeConfig.custom.disable_is_was_pricing) {
            data.compare_at_price_min = 0;
            data.compare_at_price_max = 0;
        }
        onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Convert images to array
        images = data.images_info;

        // Get First Variant (selected_or_first_available_variant)
        firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function(e) {
                return e.id == Utils.getParam('variant');
            });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        return data;
    }

    /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    /************************** BUILD PRODUCT LIST **************************/
    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data) {
        const parentEl = this.$productList[0];
        const parentHasListDsiplayClass = parentEl.classList.contains('product-list__grid--list');
        if (parentHasListDsiplayClass) {
            parentEl.classList.remove('product-list__grid--list');
        }

        if (!data) data = this.data;
        // Customize API data to get the Shopify data
        data = prepareShopifyData(data);

        var collections = data.collections;
        var comingSoonCollection = collections.filter(collection => collection['handle'] === 'coming-soon');

        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;
        // Add Custom class
        var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
        var saleClass = onSale ? boostPFSTemplate.saleClass : '';

        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

        // Add Card product class
        itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
        // Add sold out Label
        itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
        // Add Images
        itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
        // Add Price
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data, comingSoonCollection));

        // Add Review
        if (typeof Integration === 'undefined' ||
            (typeof Integration != 'undefined' &&
                typeof Integration.hascompileTemplate == 'function' &&
                !Integration.hascompileTemplate('reviews'))) {
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
        }

        // Add Vendor
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

        // Add Options
        itemHtml = itemHtml.replace(/{{itemOptions}}/g, buildOptions(data));

        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{itemButton}}/g, buildButton(data, comingSoonCollection));
        return itemHtml;
    };

    // Build Product List Item
    ProductListItem.prototype.compileTemplate = function(data, index, totalProduct) {
        const parentEl = this.$productList[0];
        const parentDontHaveListDsiplayClass = !parentEl.classList.contains('product-list__grid--list');
        if (parentDontHaveListDsiplayClass) {
            parentEl.classList.add('product-list__grid--list');
        }

        if (!data) data = this.data;
        // Customize API data to get the Shopify data
        data = prepareShopifyData(data);
        var collections = data.collections;
        var comingSoonCollection = collections.filter(collection => collection['handle'] === 'coming-soon');

        // Get Template
        var itemHtml = boostPFSTemplate.productListItemHtml;
        itemHtml = itemHtml.replace(/{{ itemTitle }}/g, data.title);
        itemHtml = itemHtml.replace(/{{ imgSrc }}/g, data.images[1]);
        itemHtml = itemHtml.replace(/{{ itemPrice }}/g, buildPrice(data, comingSoonCollection));
        itemHtml = itemHtml.replace(/{{ itemUrl }}/g, Utils.buildProductItemUrl(data));
        itemHtml = itemHtml.replace(/{{ productId }}/g, data.id);
        itemHtml = itemHtml.replace(/{{ variantId }}/g, data.variants[0].id);
        // Add Form
        itemHtml = itemHtml.replace(/{{ itemButton }}/g, buildButton(data, comingSoonCollection));
        itemHtml = itemHtml.replace(/{{ saleLabel }}/g, buildSaleLabel(data));

        var pTags = data.tags
        pTags = pTags.join(',');
        pTags = pTags.toLowerCase();
        const inStock = !data.available;
        if (inStock || comingSoonCollection.length > 0 || pTags.indexOf('preorder:') > -1) {
            itemHtml = itemHtml.replace(/{{ inStockHidden }}/g, 'product-card-list__stock--hidden');
        }

        const hideHummMessage = (data.price_max >= 80) ? false : true;

        if (hideHummMessage || comingSoonCollection.length > 0) {
            itemHtml = itemHtml.replace(/{{ hummHidden }}/g, 'product-card-list__humm--hidden');
        }

        var producDescription;
        const productDesriptionTruncateLengthInChars = 160;


        if (data.metafields.length) {
            if (data.metafields[0].key === 'main_features') {
                producDescription = data.metafields[0].value;
            }
        } else {

            producDescription = data.description.length >= productDesriptionTruncateLengthInChars ?
                data.description.slice(0, productDesriptionTruncateLengthInChars) + "..." :
                data.description;

        }

        itemHtml = itemHtml.replace(/{{ description }}/g, producDescription);

        return itemHtml;
    }

    /************************** END BUILD PRODUCT LIST **************************/
    /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildImages(data) {
        var html = '',
            rangeWidths = boostPFSRangeWidths,
            screenWidths = boostPFSScreenWidths;

        var dataSrcSet = '',
            imgAlt = data.title,
            flipImageSrcSet = '';

        var activeSwapImage = !Utils.isMobile() && images.length > 1 && boostPFSThemeConfig.custom.show_secondary_image == true;

        for (var i = 0; i < rangeWidths.length; i++) {
            dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + screenWidths[i] + 'w';

            if (activeSwapImage) {
                flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + screenWidths[i] + 'w';
            }

            if (i < rangeWidths.length - 1) {
                dataSrcSet += ', ';

                if (activeSwapImage) {
                    flipImageSrcSet += ', ';
                }
            }
        }

        if (images.length > 0) {
            html += '<div class="product-card__image-wrapper';
            if (boostPFSThemeConfig.custom.show_secondary_image == true) {
                html += ' hover-effect';
            }
            if (boostPFSThemeConfig.custom.media_size === 'square') {
                html += ' aspect-w-1 aspect-h-1';
            } else {
                html += ' aspect-w-8 aspect-h-12';
            }
            html += '">';

            if (boostPFSThemeConfig.product_card.labels_enabled) {
                html += '<div class="labels-holder">';
                if (data.compare_at_price_max > data.price_max) {
                    html += '<div class="product-label product-label--sale">' + boostPFSThemeConfig.product_card.sale_label + '</div>'
                }
                html += '</div>';
            }

            html += '<div class="image-container"><img class="';
            if (boostPFSThemeConfig.custom.image_ratio === 'square') {
                html += ' object-cover';
            } else {
                html += ' object-contain';
            }
            html += '" loading="lazy"' +
                'srcset="' + dataSrcSet + '" ' +
                'height="' + images[0].height + '" ' +
                'width="' + images[0].width + '" ' +
                'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
                'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
                'alt="' + imgAlt + '" /></div>';

            if (activeSwapImage) {
                html += '<div class="image-container product-card__secondary-image"><img class="';
                if (boostPFSThemeConfig.custom.image_ratio === 'square') {
                    html += ' object-cover';
                } else {
                    html += ' object-contain';
                }
                html += '" loading="lazy"' +
                    'srcset="' + flipImageSrcSet + '" ' +
                    'height="' + images[1].height + '" ' +
                    'width="' + images[1].width + '" ' +
                    'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
                    'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
                    'alt="' + imgAlt + '" /></div>';
            }

            html += '</div>';
        } else {
            html += '<div class="product-card__description-wrapper"><h3 class="product-card__product-title title">' + data.title + '</h3></div>'
        }
        return html;
    }

    function buildCardProductClass() {
        var html = '';
        if (!images || (images && images.length === 0)) {
            html = 'card--text-only card--soft';
        } else {
            html = 'card--outline';
        }
        return html;
    }

    function buildVendor(data) {
        var html = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') && boostPFSThemeConfig.custom.show_vendor === true) {
            html = boostPFSTemplate.vendorHtml;
        }
        return html;
    }

    function buildPrice(data, comingSoonCollection) {
        var html = '';

        if (comingSoonCollection && comingSoonCollection.length > 0) {
            var html = '';
        } else {
            var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
            var moneyPrice = Utils.formatMoney(data.price_min);
            if (!data.available || typeof data) {
							if (data.selected_or_first_available_variant) {
								if (data.unit_price_measurement === 'undefined') {
									unitPriceClass = 'hidden';
								}
							}
						}
            html = '<span class="price ' + (soldOut ? 'price--sold-out' : '') + ' ' + (onSale ? 'price--on-sale' : '') + ' ' + (noComparePrice ? 'price--no-compare' : '') + '">' +
            		'<span class="price__regular' + (onSale ? ' text-red-700' : '') + '">' +
            			'<span class="visually-hidden visually-hidden--inline">' +
            				boostPFSConfig.label.regular_price +
            			'</span>' +
            			'<span>' +
							'<span class="price-item price-item--regular" data-price-current>' +
            					moneyPrice +
            				'</span>' +
            		'</span>' +
            		'<span class="price__sale">' +
						'<span class="price__compare ' + (!data.compare_at_price_min ? 'hidden' : '') + '">' +
            				'<s class="price-item price-item--regular" data-price-compare>' +
            					Utils.formatMoney(data.compare_at_price_min) +
            				'</s>' +
            			'</span>' +
            		'</span>' +
            	'</span>';
        }

        return html;
    }

    function buildSaleLabel(data) {
        var html = '';
        if (data.compare_at_price_max > data.price_max) {
            html += '<div class="product-label product-label--sale">' + boostPFSThemeConfig.product_card.sale_label + '</div>'
        }

        return html;
    }

    function buildButton(data, comingSoonCollection) {
        var html = '';

        if (comingSoonCollection.length > 0) {
            html += '<button class="button primary-button opacity-40 cursor-not-allowed" disabled>' + boostPFSThemeConfig.product_card.coming_soon + '</button>';
        } else {
            if (data.available) {
                if (data.variants.length > 1 || data.product_type == 'Bundle') {
                    html += '<span class="button primary-button">' + boostPFSThemeConfig.product_card.more_variants + '</span>';
                } else {
                    html += '<form method="post" action="/cart/add" id="product_form_{{itemId}}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">' +
                        '<input type="hidden" name="form_type" value="product">' +
                        '<input type="hidden" name="utf8" value="✓">' +
                        '<input type="hidden" name="id" value="' + firstVariant.id + '">' +
                        '<button type="submit" name="add" class="button primary-button" data-add-to-cart>' + boostPFSThemeConfig.product_card.add_to_cart + '</button>' +
                        '</form>';
                }
            } else {
                html += '  <button class="button primary-button opacity-40 cursor-not-allowed" disabled>' + boostPFSThemeConfig.product_card.sold_out + '</button>';
            }
        }
        return html;
    }

    function buildSoldOutLabel() {
        // Build Sold out label
        var soldOutLabel = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
            soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
        }
        return soldOutLabel;
    }

    /*function buildSaleLabel() {
    	// Build Sale label
    	var saleLabel = '';
    	if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
    		saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    	}
    	return saleLabel;
    }*/

    function buildReview(data) {
        let num = (data.variants.length ? data.variants.length : 1).toString(),
            html = boostPFSTemplate.itemOptionsHtml;
        html = html.replace(/{{itemOptionsNum}}/g, num);
        return html;
    }

    function buildOptions(data) {
				let num = (data.variants.length ? data.variants.length : 1).toString(),
            html = boostPFSTemplate.itemOptionsHtml;
        html = html.replace(/{{itemOptionsNum}}/g, num);
        return html;
    }

    /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
    /************************** BUILD TOOLBAR **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        // If it has only one page, clear Pagination
        if (totalPage <= 1) {
            return '';
        }

        var paginationHtml = boostPFSTemplate.paginateHtml;
        // Build Previous
        var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        // Build Next
        var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);
        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }
        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
        return paginationHtml;
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function() {
        var html = '';
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                var paramSort = Globals.queryParams.sort || '';
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    var isSelected = ''
                    if (paramSort == k) {
                        isSelected = 'selected="selected"'
                    }
                    sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
                }
                html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            }
        }
        return html;
    };

    ProductSorting.prototype.render = function() {
        jQ(Selector.topSorting).html(this.compileTemplate());

        if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
            jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
        }

        var labelSort = '';
        var paramSort = Globals.queryParams.sort || '';
        var sortingList = Utils.getSortingList();
        if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
            labelSort = sortingList[paramSort];
        } else {
            labelSort = Labels.sorting_heading;
        }

        jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
    }

    // Build Sorting event
    ProductSorting.prototype.bindEvents = function() {
        jQ('.collection-filters__sort').change(function(e) {
            e.preventDefault();
            FilterApi.setParam('sort', jQ(this).val());
            FilterApi.setParam('page', 1);
            FilterApi.applyFilter('sort');
        });
    };

    //Build Display type
    ProductDisplayType.prototype.compileTemplate = function() {
        var html = '';
        if (boostPFSTemplate.hasOwnProperty('displayTypeHtml')) {
            var itemHtml = '';
            if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text">Grid</span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">List</span></a>';
            } else {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text">Grid</span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text">List</span></a>';
            }

            itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);
            html = boostPFSTemplate.displayTypeHtml.replace(/{{displayTypeItems}}/g, itemHtml);
        }
        return html;
    };

    // Build Show Limit
    ProductLimit.prototype.compileTemplate = function() {
        var html = '';
        if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

            var numberList = Settings.getSettingValue('general.showLimitList');
            if (numberList != '') {
                // Build content
                var showLimitItemsHtml = '';
                var arr = numberList.split(',');
                for (var k in arr) {
                    showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
                }
                html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
            }
        }
        return html;
    };

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data) {
        if (!data) data = this.data;
    }

    // Build additional elements
    Filter.prototype.afterRender = function(data, eventType) {
        var stickyElement = '.boost-pfs-filter-tree-v';
        var startElement = '.collection-list__content';
        var stickyElementParent = '.boost-pfs-filter-left-col';
        if (!Utils.isMobile()) jQ(stickyElement).stickTo(startElement, stickyElementParent);
    };


    jQ.fn.stickTo = function(startElement, stickyElementParent) {
        /* constants */
        var showingHeader = true;
        var headerSelector = '.section__header.is-sticky';
        var $window = jQ(window);
        var $startElement = jQ(startElement);
        var _this = this;
        var startPos = $startElement.offset().top;

        /* variables */
        var lastScrollTop = window.pageYOffset || document.body.scrollTop;

        /* sticky method */
        var setPosition = function() {
            /* declarations */
            var width = jQ(stickyElementParent).outerWidth();
            var $windowHeight = $window.height();
            var $contentHeight = $startElement.height();
            var $contentTop = $startElement.offset().top;

            var sidebarHeight = _this.height();
            var sidebarTop = _this.offset().top;
            var sidebarBottom = sidebarTop + sidebarHeight;

            var scrollTop = window.pageYOffset || document.body.scrollTop;
            var scrollBottom = scrollTop + $windowHeight;
            var isScrollingDown = (scrollTop > lastScrollTop);
            var endPos = $contentTop + $contentHeight;
            var headerHeight = jQ('.shopify-section-header-sticky').height() || 0;

            if (jQ('.shopify-section-header-hidden').length > 0) headerHeight = 0;


            document.addEventListener('scroll', function() {
                showingHeader = false;
                /* For the Boundless, Venture theme */
                if (jQ('.js-sticky-action-bar').length > 0 || jQ('.site-header .sticky--open').length > 0 || jQ('.site-header--fixed' || jQ('.header-wrapper--fixed'))) {
                    showingHeader = true;
                }
            });
            /* End Match Header Height Sticky */

            if (sidebarHeight > $contentHeight) {
                _this.removeClass('boost-pfs-filter-stick');
                jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
                _this.css({
                    position: 'initial'
                });
                return;
            }

            if (scrollTop <= startPos) { /* Initial Position */
                _this.removeClass('boost-pfs-filter-stick');
                jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
                _this.css({
                    position: 'initial',
                    width: '100%'
                });
                return;
            }


            if (sidebarBottom >= endPos && isScrollingDown) { /* End Position  */
                var absolutePos = endPos - sidebarHeight;
                if (absolutePos > 0) {
                    _this.removeClass('boost-pfs-filter-stick');
                    jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
                    _this.css({
                        position: 'absolute',
                        top: absolutePos,
                        bottom: 'unset',
                        width: width
                    });
                }
                return;
            }
            /* when scrolling down */
            if (isScrollingDown) {
                var visibleSideBarArea = (sidebarBottom + headerHeight);
                if (sidebarHeight > $windowHeight && (scrollBottom < visibleSideBarArea || visibleSideBarArea > $windowHeight)) { /* Until reach the sidebar bottom  */
                    if (scrollBottom <= endPos) {
                        _this.removeClass('boost-pfs-filter-stick');
                        jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
                        _this.css({
                            position: 'sticky',
                            top: $windowHeight - sidebarHeight,
                            bottom: 'unset',
                            width: '100%'
                        });
                    }
                } else if (scrollBottom <= endPos && scrollTop > startPos) { /* Sticky sidebar */
                    _this.addClass('boost-pfs-filter-stick');
                    jQ('body').addClass('boost-pfs-filter-stick-vertical-body');

                    _this.css({
                        position: 'fixed',
                        top: showingHeader ? (headerHeight + 'px') : '20px',
                        bottom: $windowHeight > (sidebarHeight + headerHeight) ? 'unset' : 0,
                        width: width,
                        left: 'auto'
                    });
                }
            } else { /* when scrolling up */
                if ((scrollTop - headerHeight) > sidebarTop) { /* Until reach the sidebar top  */
                    if (_this.css('position') !== 'relative') {
                        _this.removeClass('boost-pfs-filter-stick');
                        jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');
                        _this.css({
                            position: 'relative',
                            top: sidebarTop - $contentTop,
                            bottom: 'unset',
                            width: '100%'
                        });
                    }
                } else if (scrollTop <= (endPos - sidebarHeight)) { /* Sticky sidebar */
                    _this.addClass('boost-pfs-filter-stick');
                    jQ('body').addClass('boost-pfs-filter-stick-vertical-body');

                    _this.css({
                        position: 'fixed',
                        top: showingHeader ? (headerHeight + 'px') : '20px',
                        bottom: 'unset',
                        width: width,
                        left: 'auto'
                    });
                }
            }
            /* End when scrolling down */
            /* save last scroll position */
            lastScrollTop = window.pageYOffset || document.body.scrollTop;
        };

        /* on window resize */
        jQ(window).resize(function() {
            setPosition();
        });

        /* on scroll */
        document.addEventListener('scroll', function() {
            setPosition();
        });
        setPosition();

    };

    /************************** END BUILD TOOLBAR **************************/
})();